import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import CustomerPortal from './CustomerPortal';
import CustomerPortalLogin from './CustomerPortalLogin';
import CustomerPortalSignup from './CustomerPortalSignup';
import CustomerDocumentSign from './CustomerDocumentSign';

const CustomerPortalRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<CustomerPortalLogin />} />
      <Route path="/signup/:inviteToken" element={<CustomerPortalSignup />} />
      
      {/* Protected portal routes */}
      <Route path="/portal/*" element={<CustomerPortal />} />
      <Route path="/sign/:documentId" element={<CustomerDocumentSign />} />
      
      {/* Main customer portal - shows the map and ThetaAI search */}
      <Route path="/" element={<CustomerPortal />} />
      
      {/* Invite link redirect */}
      <Route path="/invite/:token" element={<CustomerPortal />} />
      
      {/* Map view direct access */}
      <Route path="/map" element={<CustomerPortal />} />
      
      {/* Catch all route */}
      <Route path="*" element={<CustomerPortal />} />
    </Routes>
  );
};

export default CustomerPortalRoutes;